import { createContext, useEffect, useState } from "react";
import { products } from "../Utils/bdResponseMook";

export const menuContext = createContext();

export const MenuContextProvider = ({ children }) => {
  const product = products;
  const [toShoppin, setToShoppin] = useState([]);
  const saveToLocalStorage = (items) => {
    localStorage.setItem("toShoppin", JSON.stringify(items));
  };

  const adicionalsId = [50, 51, 52];

  const getToLocalStorage = () => {
    if (localStorage.getItem("toShoppin") === null) {
      localStorage.setItem("toShoppin", JSON.stringify([]));
    } else {
      let localData = JSON.parse(localStorage.getItem("toShoppin"));
      if (localData.length > 0) {
        setToShoppin(localData);
        return;
      }
    }
  };
  useEffect(() => {
    if (toShoppin.length > 0) {
      saveToLocalStorage(toShoppin);
    } else {
      getToLocalStorage();
    }
  }, [toShoppin]);

  return (
    <menuContext.Provider
      value={{
        product,
        toShoppin,
        setToShoppin,
        saveToLocalStorage,
        adicionalsId,
      }}
    >
      {children}
    </menuContext.Provider>
  );
};
